import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { __ShowForm } from "request/Forms/__ShowForm";
import environment from "constants/apiConst";

/**
 * Hook para obtener datos de un formulario de entrada (entryForms/showEntryForm)
 * Cachea los datos para evitar peticiones duplicadas
 * 
 * @param {string|number|null} formId - ID del formulario de entrada
 * @param {boolean} enabled - Si la query debe ejecutarse (default: true)
 * @returns {Object} Objeto con data, isLoading, error, etc. de React Query
 */
export const useEntryForm = (formId, enabled = true) => {
  const token = useSelector((state) => state.auth.dataUser.token);

  return useQuery({
    queryKey: ["entryForm", formId],
    queryFn: async () => {
      if (!formId) return null;
      const res = await __ShowForm(token, formId, environment.FORMS_ENTRY_VIEW);
      return res?.data?.status?.data || null;
    },
    enabled: enabled && !!token && !!formId,
    staleTime: 1000 * 60 * 2, // 2 minutos - los datos del formulario pueden cambiar
    gcTime: 1000 * 60 * 10, // 10 minutos en caché
    refetchOnMount: false, // No refetch al montar si los datos están frescos
    refetchOnWindowFocus: false, // No refetch al cambiar de ventana
    retry: 1, // Solo reintentar una vez en caso de error
  });
};
